<template>
    <div @click="toggleFaqState()" class="faq__entry" v-bind:class="cssClass">
        <h3 class="faq__title">{{data.question}}</h3>
        <div class="faq__text">
            {{data.answer}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            cssClass: 'faq__entry--closed',
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        toggleFaqState() {
            if(this.cssClass == 'faq__entry--closed'){
                this.cssClass = 'faq__entry--open';
            }else{
                this.cssClass = 'faq__entry--closed';
            }
        }
    },
}
</script>

<style scoped>
    .faq__entry{
        border: 1px solid #D9D9D9;
        padding: 25px;
        margin-bottom: 20px;
        cursor: pointer;
    }

    .faq__entry:last-child{
        margin-bottom: 0;
    }

    .faq__entry--closed{
        background-color: #F4F4F4;
    }

    .faq__entry--open{
        background-color: #FFFFFF;
    }
    .faq__text{
        padding-top: 25px;
        display: block;
    }

    .faq__entry--closed .faq__text{
        display: none;
    }

    .faq__entry .faq__title{
        font-size: 26px;
        line-height: 34px;
        font-weight: bold;
        margin: 0;
    }
</style>